import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, Collapse, Divider, Button, Form, Select, Card, Skeleton, Avatar, message, Modal, Image, List, Input, Comment, Tooltip, InputNumber, Checkbox, Radio, Space, Table } from 'antd';
import { onUpdateTasksReminder, onGetTasksReminder, onRemoveTasksReminder, onUpdateOthersReminder, onUpdateReminderUnread } from '../../Controller/Management/TaskManagement';
import moment from 'moment';
import AppContext from "../AppContext"
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Stack from '@mui/material/Stack';
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CloseOutlined } from "@ant-design/icons";
import { Border } from 'better-xlsx/lib/style';
import { useHistory } from "react-router-dom";
import "../../css/reminder.css"
//npm i @mui/x-date-pickers
//npm i @emotion/styled

import { GetTranslation } from '../../Models/shared/general';

export default function Reminder(prop) {

  const global = useContext(AppContext)
  const userid = global.UserIdentity.userid;
  const globalgrouping = global.UserIdentity.grouping;
  const globaldepartment = global.UserIdentity.department;
  const { Panel } = Collapse;
  const { Option } = Select;
  const { TextArea, Search } = Input;
  const [filterstatus, setfilterstatus] = useState("routine");
  const [reminderdatasource, setreminderdatasource] = useState("");
  const [paneldatasource, setpaneldatasource] = useState("");
  let history = useHistory();
  const [userLists, setUserLists] = useState([]);

  const userlang = navigator.language || navigator.userLanguage;
  const [onceperiodview, setonceperiodview] = useState("hidden");
  const [repeatperiodview, setrepeatperiodview] = useState("hidden");
  const [repeatperiod, setrepeatperiod] = useState("");
  const [remindertype, setremindertype] = useState("");

  const [reminderdate, setreminderdate] = useState("");
  const [reminderdate1, setreminderdate1] = useState("");
  const [remindertime, setremindertime] = useState("");
  const [remindertime1, setremindertime1] = useState("");
  const [reminderday, setreminderday] = useState("");
  const [reminderweek, setreminderweek] = useState([]);
  const [remindermonth, setremindermonth] = useState("");
  const [remindertaskid, setremindertaskid] = useState("");
  const [reminderchatid, setreminderchatid] = useState("");
  const [remindertaskname, setremindertaskname] = useState("");
  const [remindermessage, setremindermessage] = useState("");
  const [reminderdeletebutton, setreminderdeletebutton] = useState(false);
  const [reminderobjectid, setreminderobjectid] = useState("");
  const [reminderrgroup, setreminderrgroup] = useState("");

  const [modalVisible3, setModalVisible3] = useState(false);

  const [dateWithNoInitialValue, setDateWithNoInitialValue] = useState("");

  const onGetUserLists = (data) => {
    return getAllUserLists(data)
      .then(user => {

        console.log("user, ",user)

        let usertemplist1 = user.data

        var ownuserid = usertemplist1.filter(x => x.userid == userid);

        var tempuserid = usertemplist1.filter(x => x.userid != userid);


        var usertemplist = []

        usertemplist.push({ userid: "ALL", markingcode: "ALL" })
        usertemplist.push(ownuserid[0])

        for (var x = 0; x < tempuserid.length; x++) {
          usertemplist.push(tempuserid[x])
        }

        if (globalgrouping == "public") {
          setUserLists(usertemplist);
        }
        else if (globalgrouping == "private") {
          let temptable = usertemplist
          let temptable1 = usertemplist
          var buildnew1 = temptable.filter(function (buildnew1) {
            return buildnew1.userid == userid;
          });
          var buildnew2 = temptable1.filter(function (buildnew1) {
            return buildnew1.userid == usertemplist.find(x => x.userid == userid)?.reportto || "";
          });

          if (buildnew2.length > 0) {
            buildnew1.push(buildnew2[0])
          }
          setUserLists(buildnew1)
        }
        else if (globalgrouping == "department") {

          let temptable = usertemplist
          let temptable1 = usertemplist
          var buildnew1 = temptable.filter(function (buildnew1) {
            return buildnew1.department == globaldepartment;
          });

          var buildnew2 = temptable1.filter(function (buildnew1) {
            return buildnew1.userid == usertemplist.find(x => x.userid == userid)?.reportto || "";
          });

          if (buildnew2.length > 0) {
            buildnew1.push(buildnew2[0])
          }

          setUserLists(buildnew1)

        }
        else {
          setUserLists(usertemplist);
        }

        // console.log("UserLists",userLists)

      })
      .catch(err => {
        //  message.error(GetTranslation(userlang, "Cannot get data"));
        message.error("Cannot get data");
        //setIsMaintenance(true);
      });


  }
  async function Dataloading(params) {


    var tempresult = await onGetTasksReminder(params)

    var newdatalist = []
    var newObj = {}
    var iconcolor = "red"

    tempresult.data.forEach(function (item) {
      newObj = {}

      newObj["taskname"] = item.taskname ? item.taskname : ""
      newObj["rtype"] = item.rtype ? item.rtype : ""
      newObj["rgroup"] = item.rgroup ? item.rgroup : ""
      newObj["taskid"] = item.taskid ? item.taskid : ""
      newObj["chatid"] = item.chatid ? item.chatid : ""

      newObj["message"] = item.message ? item.message : ""
      newObj["rdate"] = item.rdate ? item.rdate : ""
      newObj["rmonth"] = item.rmonth ? item.rmonth : ""

      newObj["rperiod"] = item.rperiod ? item.rperiod : ""
      newObj["rtime"] = item.rtime ? item.rtime : ""
      newObj["rweek"] = item.rweek ? item.rweek : ""
      newObj["rstatus"] = item.rstatus ? item.rstatus : ""
      newObj["_id"] = item._id ? item._id : ""
      newObj["unread"] = item.unread != undefined ? item.unread : ""

      if (item.unread != undefined) {
        if (item.unread == 0) {
          if (item.rtype == "repeat") {
            iconcolor = "green"
          }
          else if (item.rtype == "once") {
            if (item.rdate > moment().unix()) {
              iconcolor = "blue"
            }
          }
        }
      }

      newObj["iconcolor"] = iconcolor

      newdatalist.push(newObj)


    })

    setreminderdatasource(newdatalist)

    var newdatalist2 = filterdatasource(newdatalist, filterstatus)


    setpaneldatasource(newdatalist2)
  }

  async function UpdateReminderUnread(reminderid) {

    const newState = reminderdatasource.map(obj => {
      // 👇️ if id equals 2, update country property
      if (obj._id === reminderid) {
        return { ...obj, unread: 0 };
      }

      // 👇️ otherwise return object as is
      return obj;
    });

    setreminderdatasource(newState)

    filterdatasource(newState, filterstatus)

    onUpdateReminderUnread({ reminderid: reminderid })
  }
  const routechange = (taskname, taskid) => {



    if (taskid != undefined && taskid != "") {
      localStorage.removeItem("taskname")
      localStorage.removeItem("taskpage")
      localStorage.setItem("taskname", taskname)
      localStorage.setItem("taskpage", 2)
      let path = `/TaskManagement`;
      history.push(path);
    }

  }
  const panelHeader = (data) => {

    var iconcolor = "grey"

    var result22 = paneldatasource.filter(x => x._id == data._id);



    if (result22.length > 0) {
      if (result22[0].rtype == "repeat") {
        iconcolor = "green"
      }
      else if (result22[0].rtype == "once") {
        if (result22[0].rdate > moment().unix()) {
          iconcolor = "blue"
        }
        else {
          iconcolor = "red"
        }
      }

    }
    else {
      iconcolor = "grey"
    }

    var triggermessage = ""

    if (result22[0].rtype == "once") {
      triggermessage = GetTranslation(userlang, "Once") + " : " + moment.unix(result22[0].rdate).format("YYYY/MM/DD HH:mm")
    }
    else if (result22[0].rtype == "repeat") {
      if (result22[0].rperiod == "weekly") {
        console.log("weekly", result22[0].rweek)

        var newarray = []
        result22[0].rweek.forEach(function (item) {

          if (userlang == "th") {
            newarray.push(GetTranslation(userlang, item))
          }
          else {
            newarray.push(item.substr(0, 3).trim())
          }

        }
        )


        triggermessage = GetTranslation(userlang, "Weekly") + " : " + newarray + " , " + result22[0].rtime
      }
      else if (result22[0].rperiod == "monthly") {
        var monthheader = "th"
        if (result22[0].rmonth == 1) {
          monthheader = 'st'
        }
        else if (result22[0].rmonth == 2) {
          monthheader = 'nd'
        }
        else if (result22[0].rmonth == 3) {
          monthheader = 'rd'
        }
        triggermessage = GetTranslation(userlang, "Monthly") + " : " + result22[0].rmonth + monthheader + " , " + result22[0].rtime
      }
      else if (result22[0].rperiod == "yearly") {
        triggermessage = GetTranslation(userlang, "Yearly") + " : " + moment.unix(result22[0].rdate).format("MMM/DD HH:mm")
      }
    }

    // const ele       = React.createElement("small",null, [title,periodspace1,periodtitle,periodspace1,title1]);
    const ele = React.createElement("small", { style: { display: "block", color: iconcolor, textOverflow: "ellipsis", overflow: "hidden", width: "100%" } }, null, [data.taskname]);
    const ele2 = React.createElement("small", { style: { display: "block" } }, null, [data.message]);
    const ele3 = React.createElement("small", { style: { display: "block" } }, null, ["Trigger Time : "]);
    const ele4 = React.createElement("small", null, [triggermessage + "    "]);
    const ele5 = React.createElement("Button", { onClick: () => handleDelete3(result22[0]._id) }, null, ["Delete"]);

    const ele6 = React.createElement("CloseOutlined", { onClick: () => handleDelete3(result22[0]._id) }, null, ["asd"]);
    //const ele3       = React.createElement("Button",null, ["asd"]);
    const master = React.createElement("div", { style: { width: "100%" } }, null, [ele, ele2, ele4, ele5]);


    // return master;

    return (
      <>

        {/* <div style={{width:"100%"}}>
          <small style={{display: "block", color:iconcolor,textOverflow:"ellipsis", overflow:"hidden",width:"100%"}}>
            {data.taskname}
          </small>
          <small style={{display: "block"}}>
            {data.message}
          </small>
          <small style={{display: "block"}}>
            {triggermessage}
          </small>
          <Button style={{ backgroundColor:"#f0f2f5",
          display:data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" :"" }}>
            Postpone
          </Button>
          &nbsp;&nbsp;
          &nbsp;&nbsp;
          <CloseOutlined  onClick={(val) => { handleDelete3(result22[0]._id)}} style={{color:"red",  fontSize:"16px", 
          display:data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" :"" }}></CloseOutlined>
        
          </div> */}
        <List.Item
          actions={[
            <Button style={{
              display: data.unread == 1 ? "" : "none",
              borderRadius: "10px", backgroundColor: "#f0f2f5", padding: "4px 4px"
            }}>
              <a style={{
                backgroundColor: "#f0f2f5", fontSize: "12px",
                display: data.unread == 1 ? "" : "none", color: "red"
              }}
                onClick={() => { UpdateReminderUnread(data._id) }}>
                {GetTranslation(userlang, "Read")}
              </a></Button>,
            <Button style={{
              display: data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" : data.rtype != "repeat" ? "none" : "",
              borderRadius: "10px", backgroundColor: "#f0f2f5", padding: "4px 4px"
            }}>
              <a style={{
                backgroundColor: "#f0f2f5", color: "blue", fontSize: "12px",
                display: data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" : data.rtype != "repeat" ? "none" : ""
              }}
                onClick={(val) => { showModal3(val, data) }}>
                {GetTranslation(userlang, "Postpone")}
              </a></Button>,
            <Button style={{
              display: data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" : "",
              borderRadius: "10px", backgroundColor: "#f0f2f5", padding: "4px 4px"
            }}>
              <a onClick={(val) => { handleDelete3(result22[0]._id) }}
                style={{
                  backgroundColor: "#f0f2f5", color: "red", fontSize: "12px",
                  display: data.rgroup == "deadline" ? "none" : data.rstatus == 0 ? "none" : ""
                }}>{GetTranslation(userlang, "Del")}</a> </Button>]}>

          <List.Item.Meta
            style={{ width: "80%" }}
            title={
              <>
                <a
                  onClick={(val) => { routechange(data.taskname, data.taskid) }}
                  style={{ color: data.iconcolor, fontSize: "14px", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                  {data.taskname}
                </a>
              </>
            }
            description={
              <>
                <small style={{ display: "block", fontSize: "12px", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                  {data.message}
                </small>
                <small style={{ fontSize: "12px", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                  {triggermessage}
                </small>
              </>
            }
          />


        </List.Item>

      </>
    )
  }
  const handleDelete3 = (val) => {


    var answer = window.confirm("Are you sure want to delete this Reminder?")


    if (answer == true) {
      const result = deleteReminder(val);
    }

  }


  const reminderrenderItem = (item) => {

    return (
      //  <Collapse 
      // expandIconPosition={'right'} 
      // accordion
      //onChange={onTaskChange}
      // activeKey={collapse}
      //  >
      <div >
        {panelHeader(item)}
        {/* <List
        itemLayout="horizontal"
        dataSource={paneldatasource}
        >

        </List> */}
        {/*<Panel 
      header={panelHeader(item)} 
      key={item._id}
      className="taskPanel"
     // extra={genExtra(item)}
       >
          <div>
           {"Group : " + item.rgroup.toString().toUpperCase()}
         </div> */}
        {/* <div>
           {"Type : " + item.rtype.toString().toUpperCase()}
         </div>
         <div style={{display:item.rperiod != "" ? "block" : "none"}}>
           {"Period : " + item.rperiod.toString().toUpperCase()}
         </div>
         <div style={{display:item.rtype == "once" ? "block" : "none"}}>
           {"Date : " + moment.unix(item.rdate).format("YYYY/MM/DD HH:mm")}
         </div>
         <div style={{display:item.rperiod == "weekly" ? "block" : "none"}}>
           {"Weekdays : " + item.rweek}
         </div>
         <div style={{display:item.rperiod == "monthly" ? "block" : "none"}}>
           {"Monthly : " + item.rmonth}
         </div>
         <div style={{display:item.rperiod == "yearly" ? "block" : "none"}}>
           {"Yearly : " + moment.unix(item.rdate).format("MM/DD HH:mm")}
         </div> 
       
      </Panel>*/}
      </div>


      //  </Collapse>

    )
  }

  const tasklistProps = {
    // loading     : taskinitLoading,
    // loadMore    : taskloadMore,
    itemLayout: "horizontal",
    dataSource: paneldatasource,
    renderItem: reminderrenderItem
  }

  const showModal3 = (val, result) => {

    if (result._id) {
      setreminderobjectid(result._id)

    }
    else {
      setreminderobjectid("")
      setremindertaskid("")
      setreminderchatid("")

    }
    setremindertype("repeat")
    setonceperiodview("hidden")
    setrepeatperiodview("visible")





    var result11 = reminderdatasource.filter(x => x._id == result._id);


    if (result11[0]) {
      setremindertaskname(result11[0].taskname)
      setremindermessage(result11[0].message)
      setrepeatperiod(result11[0].rperiod)
      setreminderdate(result11[0].rdate)
      setremindertime(result11[0].rtime)
      setreminderweek(result11[0].rweek)
      setremindermonth(result11[0].rmonth)
      setremindertype(result11[0].rtype)
      setreminderrgroup(result11[0].rgroup)
      setremindertaskid(result11[0].taskid)
      setreminderchatid(result11[0].chatid)
      setremindertime1(dayjs(result11[0].rtime, "HH:mm"))


      var monthdateFormat = "MM/DD HH:mm"

      setreminderdate1(dayjs(moment.unix(result11[0].rdate).format(monthdateFormat), monthdateFormat))

      setreminderobjectid(result11[0]._id)
      setreminderdeletebutton(true)

      if (result11[0].rtype == "once") {
        setonceperiodview("visible")
        setremindertype("once")

        setrepeatperiodview("hidden")
      }

      else {
        setonceperiodview("hidden")
        setremindertype("repeat")
        setrepeatperiodview("visible")
      }
    }

    else {
      setremindertaskname(result.taskname)
      setremindermessage("")
      setreminderdeletebutton(false)
      setreminderrgroup("others")
    }

    setModalVisible3(true);




  };

  const handleCancel3 = (val, result) => {


    setModalVisible3(false);

    setonceperiodview("hidden")
    setrepeatperiodview("hidden")
    setremindertaskid("")
    setrepeatperiod("")
    setreminderdate("")
    setremindertime("")
    setreminderweek([])
    setremindermonth("")
    setremindertype("")
  };

  function typechange(e) {


    if (e == "once") {
      setonceperiodview("visible")
      setremindertype("once")

      setrepeatperiodview("hidden")
    }
    else {
      setonceperiodview("hidden")
      setremindertype("repeat")
      setrepeatperiodview("visible")
    }


    setreminderdate("")
    setremindertime("")
    setreminderweek([])
    setremindermonth("")
  }

  function periodchange(e) {

    console.log('period >>>>', e)
    if (e == "weekly") {
      setrepeatperiod("weekly")
    }
    else if (e == "monthly") {
      setrepeatperiod("monthly")
    }
    else if (e == "yearly") {
      setrepeatperiod("yearly")
    }

    //   setreminderdate("")
    //   setremindertime("")
    //   setreminderweek([])
    //   setremindermonth("")
  }

  function datechange(e) {
    //   setreminderdate(moment(e).format("YYYYMMDD"))

    if (e != null) {
      setremindertime(e.$H.toString().padStart(2, "0") + ":" + e.$m.toString().padStart(2, "0"))
      setreminderdate(moment(e.$d).format("YYYYMMDD"))
      setreminderdate1(e)
    }

  }

  function timechange(e) {
    if (e != null) {
      setremindertime(e.$H.toString().padStart(2, "0") + ":" + e.$m.toString().padStart(2, "0"))
      setremindertime1(e)
    }
  }


  const ReminderForm = () => {

    if (onceperiodview == "visible") {

      return (
        <div>


          <Form >
            <br />
            <Form.Item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack>
                  <DateTimePicker
                    label={GetTranslation(userlang, "Once Date Time")}
                    value={reminderdate1 ? reminderdate1 : null}
                    onChange={datechange}
                    minDate={dayjs()}
                    inputFormat="MM/DD hh:mm a"
                    renderInput={(params) => <TextField {...params} />}
                  >

                  </DateTimePicker>
                </Stack>

              </LocalizationProvider>

            </Form.Item>
          </Form>
        </div>
      )

    }

    else if (repeatperiodview == "visible") {
      return (
        <div>
          <Form>
            <br />
            <Form.Item>
              <Select style={{ width: "60%" }} placeholder={GetTranslation(userlang, "Select Period")} defaultValue={repeatperiod ? repeatperiod : null} onChange={periodchange}  >
                <Option value={"weekly"}>{GetTranslation(userlang, "Weekly")}</Option>
                <Option value={"monthly"}>{GetTranslation(userlang, "Monthly")}</Option>
                <Option value={"yearly"}>{GetTranslation(userlang, "Yearly")}</Option>
              </Select>
            </Form.Item>

            {RepeatForm()}

            {/* <Form.Item>
                   <TimePicker format={"HH:mm"} style={{width: "60%"}} 
                   defaultValue={remindertime ? moment(remindertime,"HH:mm"): null} minuteStep={10} onChange={timechange}
                   inputReadOnly>
                       
                   </TimePicker>
               </Form.Item> */}
          </Form>
        </div>
      )
    }
  }

  const weekdaychange = (checkedValues) => {

    setreminderweek(checkedValues)

  };

  const monthchange = (Values) => {

    setremindermonth(Values)


  };
  const tasknamechange = (Values) => {


    setremindertaskname(Values)


  };

  const messagechange = (Values) => {


    setremindermessage(Values)


  };

  const RepeatForm = () => {

    const weekdayslist = [

      {
        label: GetTranslation(userlang, 'Monday'),
        value: 'Monday',
      },
      {
        label: GetTranslation(userlang, 'Tuesday'),
        value: 'Tuesday',
      },
      {
        label: GetTranslation(userlang, 'Wednesday'),
        value: 'Wednesday',
      },
      {
        label: GetTranslation(userlang, 'Thursday'),
        value: 'Thursday',
      },
      {
        label: GetTranslation(userlang, 'Friday'),
        value: 'Friday',
      },
      {
        label: GetTranslation(userlang, 'Saturday'),
        value: 'Saturday',
      },
      {
        label: GetTranslation(userlang, 'Sunday'),
        value: 'Sunday',
      },
    ]
    if (repeatperiod == "weekly") {
      return (
        <Form.Item>
          <Checkbox.Group className="ant-checkbox-group"
            style={{ display: "inline-grid" }} options={weekdayslist} defaultValue={reminderweek ? reminderweek : null} onChange={weekdaychange} />

          <div>
            <br />
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack>
              <TimePicker
                label={GetTranslation(userlang, "Weekly Time")}
                value={remindertime1 ? remindertime1 : null}
                onChange={timechange}
                inputFormat="hh:mm a"
                renderInput={(params) => <TextField {...params} />}
              >

              </TimePicker>
            </Stack>

          </LocalizationProvider>
        </Form.Item>
      )
    }
    else if (repeatperiod == "monthly") {
      return (
        <Form.Item>
          <Select style={{ width: "60%" }} placeholder={GetTranslation(userlang, "Select Date")} defaultValue={remindermonth ? remindermonth : null} onChange={monthchange} allowClear showSearch >
            <Option value={"1"}>{"1"}</Option>
            <Option value={"2"}>{"2"}</Option>
            <Option value={"3"}>{"3"}</Option>
            <Option value={"4"}>{"4"}</Option>
            <Option value={"5"}>{"5"}</Option>
            <Option value={"6"}>{"6"}</Option>
            <Option value={"7"}>{"7"}</Option>
            <Option value={"8"}>{"8"}</Option>
            <Option value={"9"}>{"9"}</Option>
            <Option value={"10"}>{"10"}</Option>
            <Option value={"11"}>{"11"}</Option>
            <Option value={"12"}>{"12"}</Option>
            <Option value={"13"}>{"13"}</Option>
            <Option value={"14"}>{"14"}</Option>
            <Option value={"15"}>{"15"}</Option>
            <Option value={"16"}>{"16"}</Option>
            <Option value={"17"}>{"17"}</Option>
            <Option value={"18"}>{"18"}</Option>
            <Option value={"19"}>{"19"}</Option>
            <Option value={"20"}>{"20"}</Option>
            <Option value={"21"}>{"21"}</Option>
            <Option value={"22"}>{"22"}</Option>
            <Option value={"23"}>{"23"}</Option>
            <Option value={"24"}>{"24"}</Option>
            <Option value={"25"}>{"25"}</Option>
            <Option value={"26"}>{"26"}</Option>
            <Option value={"27"}>{"27"}</Option>
            <Option value={"28"}>{"28"}</Option>
          </Select>
          <div>
            <br />
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack>
              <TimePicker
                label={GetTranslation(userlang, "Monthly Time")}
                value={remindertime1 ? remindertime1 : null}
                onChange={timechange}
                inputFormat="hh:mm a"
                renderInput={(params) => <TextField {...params} />}
              >

              </TimePicker>
            </Stack>

          </LocalizationProvider>
        </Form.Item>
      )
    }
    else if (repeatperiod == "yearly") {
      return (
        <Form.Item>
          {/* <DatePicker style={{width: "60%"}}
           defaultValue={reminderdate ? moment.unix(reminderdate): null}
          format="MM-DD"
          onChange={datechange}>

         </DatePicker> */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack>
              <DateTimePicker
                label={GetTranslation(userlang, "Yearly Time")}
                value={reminderdate1 ? reminderdate1 : null}
                onChange={datechange}
                minDate={dayjs()}
                inputFormat="MM/DD hh:mm a"
                renderInput={(params) => <TextField {...params} />}
              >

              </DateTimePicker>
            </Stack>

          </LocalizationProvider>

        </Form.Item>
      )
    }

  }

  const handleOk3 = (val) => {

    // console.log("task id >>>>", remindertaskid)
    // console.log("remindertype >>>",remindertype)
    // console.log("repeatperiod >>>",repeatperiod)
    console.log("reminderdate >>>", reminderdate)
    //  console.log("remindertime >>>", remindertime)
    //  console.log("reminderweek >>>",reminderweek)
    // console.log("remindermonth >>>",remindermonth)
    var tempreminderdate = reminderdate
    if (Number.isInteger(tempreminderdate) == true) {
      tempreminderdate = moment.unix(tempreminderdate).format("YYYYMMDD").toString()
      console.log("tempreminderdate >>>>", tempreminderdate)
    }
    var currentdate = tempreminderdate + " " + remindertime
    // console.log("reminder currentdate1 >>", currentdate)
    var currentdate1 = moment(currentdate, "YYYYMMDD, HH:mm").format()
    // console.log("reminder currentdate5 >>", moment(currentdate1).unix())
    //  console.log("remindertaskname >>>",remindertaskname)
    //  console.log("remindermessage >>>",remindermessage)

    // console.log("tempreminderdate >>>>",tempreminderdate)
    var crontab = ""
    var splitvar = remindertime.split(":")
    console.log("splitvar >>>", splitvar)
    if (remindertype == "once") {


      crontab = splitvar[1].toString() + " " +
        splitvar[0].toString() + " " +
        moment(tempreminderdate).format("DD").toString() + " " +
        moment(tempreminderdate).format("MM").toString() + " " +
        "*"
    }
    else {
      if (repeatperiod == "weekly") {
        var weekstring = ''
        if (reminderweek) {
          for (var x = 0; x < reminderweek.length; x++) {
            if (reminderweek[x] == "Monday") {
              if (weekstring.length == 0) {
                weekstring = "0"
              }
              else {
                weekstring = weekstring + ",0"
              }

            }
            else if (reminderweek[x] == "Tuesday") {
              if (weekstring.length == 0) {
                weekstring = "1"
              }
              else {
                weekstring = weekstring + ",1"
              }
            }
            else if (reminderweek[x] == "Wednesday") {
              if (weekstring.length == 0) {
                weekstring = "2"
              }
              else {
                weekstring = weekstring + ",2"
              }
            }
            else if (reminderweek[x] == "Thursday") {
              if (weekstring.length == 0) {
                weekstring = "3"
              }
              else {
                weekstring = weekstring + ",3"
              }
            }
            else if (reminderweek[x] == "Friday") {
              if (weekstring.length == 0) {
                weekstring = "4"
              }
              else {
                weekstring = weekstring + ",4"
              }
            }
            else if (reminderweek[x] == "Saturday") {
              if (weekstring.length == 0) {
                weekstring = "5"
              }
              else {
                weekstring = weekstring + ",5"
              }
            }
            else if (reminderweek[x] == "Sunday") {
              if (weekstring.length == 0) {
                weekstring = "6"
              }
              else {
                weekstring = weekstring + ",6"
              }
            }
          }
        }

        crontab = splitvar[1].toString() + " " +
          splitvar[0].toString() + " " +
          "*" + " " +
          "*" + " " +
          weekstring
      }
      if (repeatperiod == "monthly") {
        crontab = splitvar[1].toString() + " " +
          splitvar[0].toString() + " " +
          remindermonth + " " +
          "*" + " " +
          "*"
      }
      if (repeatperiod == "yearly") {
        crontab = splitvar[1].toString() + " " +
          splitvar[0].toString() + " " +
          moment(tempreminderdate).format("DD").toString() + " " +
          moment(tempreminderdate).format("MM").toString() + " " +
          "*"
      }
    }


    // console.log("crontab >>>>",crontab)

    var data =
    {
      taskid: remindertaskid,
      chatid: reminderchatid,
      taskname: remindertaskname,
      message: remindermessage,
      rgroup: reminderrgroup,
      rtype: remindertype,
      rperiod: repeatperiod,
      rdate: moment(currentdate1).unix(),
      rtime: remindertime,
      rweek: reminderweek,
      rmonth: remindermonth,
      rstatus: 1,
      createdby: userid,
      crontab: crontab
    }


    if (remindertype) {
      if (remindertype == "once") {
        if (reminderdate) {
          if (remindertime) {
            const result = updateReminder(data);
          }
          else {
            message.error("Please Select Reminder Time");
          }
        }
        else {
          message.error("Please Select Reminder Date");
        }
      }
      else {
        if (repeatperiod == "weekly") {
          if (reminderweek.length > 0) {
            if (remindertime) {
              const result = updateReminder(data);
            }

            else {
              message.error("Please Select Reminder Time");
            }
          }
          else {
            message.error("Please Tick atleast 1 day");
          }
        }
        else if (repeatperiod == "monthly") {
          if (remindermonth) {
            if (remindertime) {
              const result = updateReminder(data);
            }

            else {
              message.error("Please Select Reminder Time");
            }
          }
          else {
            message.error("Please Select Reminder Month");
          }
        }
        else if (repeatperiod == "yearly") {
          if (reminderdate) {
            if (remindertime) {
              const result = updateReminder(data);
            }
            else {
              message.error("Please Select Reminder Time");
            }
          }
          else {
            message.error("Please Select Reminder Date");
          }
        }

        else {
          message.error("Please Select Reminder Repeat Period");
        }
      }
    }
    else {
      message.error("Please Select Reminder Type");
    }


  }
  async function updateReminder(data) {

    const result = await onUpdateTasksReminder(data);
    if (result && result.status === "ok") {
      message.success(result.msg);

      setModalVisible3(false);

      setonceperiodview("hidden")
      setrepeatperiodview("hidden")
      setremindertaskid("")
      setreminderchatid("")
      setrepeatperiod("")
      setreminderdate("")
      setremindertime("")
      setreminderweek([])
      setremindermonth("")
      setremindertype("")
      setremindertaskname("")
      setremindermessage("")

      setreminderobjectid("")
      setremindertime1("")
      setreminderdate1("")

      Dataloading({ createdby: userid })
    }
    else {
      message.error(result.msg);

    }
  };

  async function deleteReminder(data) {
    const result = await onRemoveTasksReminder({ _id: data });
    if (result && result.status === "ok") {
      message.success(result.msg);

      setModalVisible3(false);

      setonceperiodview("hidden")
      setrepeatperiodview("hidden")
      setremindertaskid("")
      setreminderchatid("")
      setrepeatperiod("")
      setreminderdate("")
      setremindertime("")
      setreminderweek([])
      setremindermonth("")
      setremindertype("")
      setremindertaskname("")
      setremindermessage("")

      Dataloading({ createdby: userid })
    }
    else {
      message.error(result.msg);

    }
  };

  function filterchange(params) {

    setfilterstatus(params)


    var tempdatasource = reminderdatasource

    filterdatasource(tempdatasource, params)
  }

  function filterdatasource(Pdatasource, Pfilter) {

    var newdatalist = []
    var newObj = {}


    if (Pfilter == 'active') {
      Pdatasource.forEach(function (item) {
        if (item.rstatus == 1) {
          if (item.rtype == "once") {
            newObj = {}
            var iconcolor = "red"
            newObj["taskname"] = item.taskname ? item.taskname : ""
            newObj["rtype"] = item.rtype ? item.rtype : ""
            newObj["rgroup"] = item.rgroup ? item.rgroup : ""
            newObj["taskid"] = item.taskid ? item.taskid : ""
            newObj["chatid"] = item.chatid ? item.chatid : ""
            newObj["message"] = item.message ? item.message : ""
            newObj["rdate"] = item.rdate ? item.rdate : ""
            newObj["rmonth"] = item.rmonth ? item.rmonth : ""

            newObj["rperiod"] = item.rperiod ? item.rperiod : ""
            newObj["rtime"] = item.rtime ? item.rtime : ""
            newObj["rweek"] = item.rweek ? item.rweek : ""
            newObj["rstatus"] = item.rstatus ? item.rstatus : ""
            newObj["_id"] = item._id ? item._id : ""
            newObj["unread"] = item.unread != undefined ? item.unread : ""

            if (item.unread != undefined) {
              if (item.unread == 0) {
                if (item.rtype == "repeat") {
                  iconcolor = "green"
                }
                else if (item.rtype == "once") {
                  if (item.rdate > moment().unix()) {
                    iconcolor = "blue"
                  }
                }
              }
              else {
                iconcolor = "red"
              }
            }
            newObj["iconcolor"] = iconcolor

            newdatalist.push(newObj)


          }


        }



      })
    }
    else if (Pfilter == 'expired') {
      Pdatasource.forEach(function (item) {
        if (item.rstatus == 0) {

          newObj = {}
          var iconcolor = "grey"
          newObj["taskname"] = item.taskname ? item.taskname : ""
          newObj["rtype"] = item.rtype ? item.rtype : ""
          newObj["rgroup"] = item.rgroup ? item.rgroup : ""
          newObj["taskid"] = item.taskid ? item.taskid : ""
          newObj["chatid"] = item.chatid ? item.chatid : ""
          newObj["message"] = item.message ? item.message : ""
          newObj["rdate"] = item.rdate ? item.rdate : ""
          newObj["rmonth"] = item.rmonth ? item.rmonth : ""

          newObj["rperiod"] = item.rperiod ? item.rperiod : ""
          newObj["rtime"] = item.rtime ? item.rtime : ""
          newObj["rweek"] = item.rweek ? item.rweek : ""
          newObj["rstatus"] = item.rstatus ? item.rstatus : ""
          newObj["_id"] = item._id ? item._id : ""
          newObj["unread"] = item.unread != undefined ? item.unread : ""

          if (item.unread != undefined) {
            if (item.unread == 0) {
              if (item.rtype == "repeat") {
                iconcolor = "green"
              }
              else if (item.rtype == "once") {
                if (item.rdate > moment().unix()) {
                  iconcolor = "blue"
                }
              }
            }
            else {
              iconcolor = "red"
            }
          }
          newObj["iconcolor"] = iconcolor

          newdatalist.push(newObj)


        }



      })
    }
    else if (Pfilter == 'routine') {
      Pdatasource.forEach(function (item) {
        if (item.rstatus == 1) {
          if (item.rtype != "once") {
            newObj = {}
            var iconcolor = "grey"
            newObj["taskname"] = item.taskname ? item.taskname : ""
            newObj["rtype"] = item.rtype ? item.rtype : ""
            newObj["rgroup"] = item.rgroup ? item.rgroup : ""
            newObj["taskid"] = item.taskid ? item.taskid : ""
            newObj["chatid"] = item.chatid ? item.chatid : ""
            newObj["message"] = item.message ? item.message : ""
            newObj["rdate"] = item.rdate ? item.rdate : ""
            newObj["rmonth"] = item.rmonth ? item.rmonth : ""

            newObj["rperiod"] = item.rperiod ? item.rperiod : ""
            newObj["rtime"] = item.rtime ? item.rtime : ""
            newObj["rweek"] = item.rweek ? item.rweek : ""
            newObj["rstatus"] = item.rstatus ? item.rstatus : ""
            newObj["_id"] = item._id ? item._id : ""
            newObj["unread"] = item.unread != undefined ? item.unread : ""

            if (item.unread != undefined) {
              if (item.unread == 0) {
                if (item.rtype == "repeat") {
                  iconcolor = "green"
                }
                else if (item.rtype == "once") {
                  if (item.rdate > moment().unix()) {
                    iconcolor = "blue"
                  }
                }
              }
              else {
                iconcolor = "red"
              }
            }
            newObj["iconcolor"] = iconcolor

            newdatalist.push(newObj)


          }
        }


      })

    }

    setpaneldatasource(newdatalist)

    return newdatalist
  }




  useEffect(() => {

    onGetUserLists({})
    Dataloading({ createdby: userid })
    

  }, []);
  return (
    <>
      <Row justify="start">
        <Divider>{GetTranslation(userlang, prop.title) ?? "."}</Divider>
      </Row>

      <Row >
        <Col style={{ display: "flex", width: "100%" }} offset={1} >
          {/* <Select value={filterstatus}  onChange={(e) => filterchange(e)}>
                            <Option value={"active"}>{"Active"}</Option>
                            <Option value={"expired"}>{"Expired"}</Option>
                            <Option value={"routine"}>{"Routine"}</Option>
                          
                        </Select>
                        &nbsp;&nbsp;&nbsp; */}
          <Button onClick={(val) => { showModal3(val, reminderdatasource) }} type='primary'>
            {GetTranslation(userlang, "ADD")}
          </Button>

          {/* <Button onClick={(val) => { filterchange("active") }} style={{ color: "blue", marginLeft: "auto", border: "none", backgroundColor: "#f0f2f5" }} > {GetTranslation(userlang, "Active")}</Button> */}

          <Button onClick={(val) => { filterchange("routine") }} style={{ color: "rgb(41,144,64)", border: "none", backgroundColor: "#f0f2f5" }}>{GetTranslation(userlang, "Routine")}</Button>

          <Button onClick={(val) => { filterchange("expired") }} style={{ color: "red", border: "none", backgroundColor: "#f0f2f5" }}> {GetTranslation(userlang, "Deleted")}</Button>

          <Modal
            destroyOnClose={true}
            title={GetTranslation(userlang, "Reminder")}
            visible={modalVisible3}
            onOk={(val) => { handleOk3(val, reminderdatasource) }}
            onCancel={(val) => { handleCancel3(val, reminderdatasource) }}

          >

            {
              reminderobjectid != "" ?

                <div>
                  <TextArea placeholder={GetTranslation(userlang, "Task Name")} disabled defaultValue={remindertaskname} onChange={(e) => tasknamechange(e.target.value)} autoSize />
                </div>
                :
                <div>
                  <TextArea placeholder={GetTranslation(userlang, "Task Name")} defaultValue={remindertaskname} onChange={(e) => tasknamechange(e.target.value)} autoSize />
                </div>
            }

            <br />
            <div>
              <TextArea placeholder={GetTranslation(userlang, "Message")} defaultValue={remindermessage ? remindermessage : null} onChange={(e) => messagechange(e.target.value)} autoSize />

            </div>


            {/* <br/>
            <div style={{ width: "100%" }}>
              <Select style={{ width: "100%" }} placeholder={"Assign To"} mode="multiple" allowClear showSearch>
                {

                  userLists.map(function (data) {
                    return (
                      // <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                      <></>
                    )
                  })
                }
              </Select>
            </div> */}

            {/* <Select style={{width: "60%"}} defaultValue={remindertype ? remindertype: null} placeholder={"Select Type"} onChange={typechange}  >
                         <Option value={"once"}>{"Once"}</Option>
                         <Option value={"repeat"}>{"Repeat"}</Option>
                    </Select> */}
            {/* <br/>
                    <br/> */}
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack>
                      <DateTimePicker
          value={dateWithNoInitialValue}
          onChange={(newValue) => testingchangedata(newValue)}
          renderInput={(params) => (
            <TextField {...params} />
          )}
        />
                      </Stack>
    </LocalizationProvider> */}
            {ReminderForm()}
          </Modal>
        </Col>
      </Row>

      <br />
      <Col span={22} offset={1}>


        <List {...tasklistProps}></List>

      </Col>
    </>
  )
}